import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fef63e5e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=fef63e5e&prod&scoped=true&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=fef63e5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef63e5e",
  null
  
)

export default component.exports